import "./Tabs.scss";
import React from "react";

interface Tab {
    label: string;
    content: React.ReactNode;
    isDisabled?: boolean;
}

interface TabsProps {
    tabs: Tab[];
    activeTab: number;
    className?: string;
    onChange: (index: number) => void;
    bgColor?: string;
}

const Tabs: React.FC<TabsProps> = ({
    tabs,
    onChange,
    activeTab,
    className,
    bgColor,
}) => (
    <div className="flex flex-col w-full relative">
        <div
            className={`flex pl-[16px] ${className ? className : ""
                } overflow-x-auto scroll-smooth min-w-full border-b-darkcolor-400 border-b-[1px]`}
        >
            <div className="flex gap-[14px] min-w-max">
                {tabs.map((tab, index) => (
                    <div
                        key={index}
                        className="cursor-pointer text-neutral-25 hover:bg-darkcolor-600 focus:outline-none tab-item"
                        onClick={() => !tab.isDisabled && onChange(index)}
                    >
                        <div className="flex items-center px-1">
                            <span
                                className={`text-sm font-semibold pt-4 pb-3 border-b-2 hover:bg-darkcolor-600 ${activeTab === index
                                        ? "border-secondary-400 text-primary-400"
                                        : "border-transparent"
                                    } ${tab?.isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                                {tab.label}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        <div
            className={`py-5 px-5 xl:px-5 tabs-content flex-grow min-h-[400px] ${tabs[activeTab]?.isDisabled
                    ? "text-darkcolor-400 opacity-50 cursor-not-allowed"
                    : `${bgColor ? bgColor : "bg-darkcolor-700"}`
                }`}
        >
            {tabs[activeTab]?.content || <></>}
        </div>
    </div>
);

export default Tabs;
